export default __webpack_public_path__ + "static/media/Text(bid).1d0a845e.svg";